/* eslint-disable no-useless-escape */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phoneNumber' })
export class PhoneNumberPipe implements PipeTransform {
  private phoneRegex =
    /^\+?1?[.\-]?\(?(\d{3})\)?[ .\-]?(\d{3})[.\-]?(\d{4})\s?((x|ext)\.?\s?([0-9]+))?$/i;

  transform(value: string | undefined): string | undefined {
    if (!value) {
      return value;
    }

    const match = this.phoneRegex.exec(value);

    if (match === null) {
      return undefined;
    }

    const ext = match[6];
    return `(${match[1]}) ${match[2]}-${match[3]}${this.getExtension(ext)}`;
  }

  private getExtension(ext?: string): string {
    return ext ? ` ext. ${ext}` : '';
  }
}
